import React from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils';
import { DateFormats } from 'constants/common';
import { CopyAll } from '@mui/icons-material';
import { useVO } from 'modules/vendorOpportunity';
import { CustomerVendorOpportunity } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Tooltip, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { customersApi } from '../../../../../api';

interface Props {
  customerOpportunities: CustomerVendorOpportunity[];
}

export const ActiveOpportunitiesCard = ({ customerOpportunities }: Props) => {
  const { isVODuplicating, handleDuplicateVO } = useVO();

  return (
    <CardContainer title="Opportunities">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Sales Rep</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {customerOpportunities?.map(o => (
            <TableRow key={o.vendorOpportunityId}>
              <TableCell>{moment(o.createdDateTime).format(DateFormats.DateTimeShort12Hour)}</TableCell>
              <TableCell>{o.salesRepresentative?.fullName}</TableCell>
              <TableCell>{formatCurrency(o.invoiceTotal)}</TableCell>
              <TableCell>{o.transactionStage}</TableCell>

              <TableCell>
                <Stack direction="row" gap="0.5rem">
                  <Tooltip title="Duplicate Opportunity">
                    <IconButton
                      size="small"
                      color="primary"
                      loading={isVODuplicating}
                      className="icon-btn-bordered"
                      onClick={() =>
                        handleDuplicateVO(o.vendorOpportunityId, () => ({
                          awaitRefetchQueries: true,
                          refetchQueries: [customersApi.getCustomerOpportunities],
                        }))
                      }
                    >
                      <CopyAll />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContainer>
  );
};
